<template>
	<router-view />
</template>
<style>
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	nav {
		padding: 30px;
	}

	nav a {
		font-weight: bold;
		color: #2c3e50;
	}

	nav a.router-link-exact-active {
		color: #42b983;
	}

	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	@font-face {
		font-family: 'ChuangKeTieJinGangTi';
		src: url('./assets/ChuangKeTieJinGangTi.otf') format('truetype');
		font-weight: normal;
		font-style: normal;
	}

	.el-input-number .el-input__inner{
		text-align: left !important;
	}
</style>